import { renderChatMarkdown } from '../../lib/chat-markdown';
import { MarkdownView } from '../MarkdownView';
import { EmailSignature } from './EmailSignature';

export function EmailPreview({
  from,
  recipients,
  cc,
  subject,
  body,
  senderName,
  senderTitle,
  senderEmail,
  senderPhone,
}: {
  from?: string;
  recipients: string;
  cc?: string;
  subject: string;
  body: string;
  senderName?: string;
  senderTitle?: string;
  senderEmail?: string;
  senderPhone?: string;
}) {
  return (
    <section className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-800 dark:bg-gray-900">
      <p className="text-xs font-medium uppercase tracking-wide text-gray-500">Email that will be sent</p>
      {from ? <p className="mt-2 text-sm">From: {from}</p> : null}
      <p className="mt-2 text-sm">To: {recipients || 'No recipients'}</p>
      {cc ? <p className="text-sm">Cc: {cc}</p> : null}
      <p className="text-sm font-medium">{subject || 'No subject'}</p>
      <div className="mt-3 border-t border-gray-200 pt-3 dark:border-gray-800">
        {body.trim() ? <MarkdownView html={renderChatMarkdown(body)} /> : <p className="text-sm text-gray-500">No email body.</p>}
        <EmailSignature name={senderName} title={senderTitle} email={senderEmail} phone={senderPhone} />
      </div>
    </section>
  );
}
